import { useMutation, useQueryClient } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const useSignIn = (postData) => {
  return http().post(endpoints.auth.signIn, postData);
};

export function usePostSignIn() {
  const queryClient = useQueryClient();
  return useMutation(useSignIn, {
    onSuccess: () => {
      queryClient.invalidateQueries(["useSignIn"]);
    },
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
